export default __webpack_public_path__ + "static/media/support.1767c2a2.svg";